// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesList_serviceList__16N3Z {
  margin-top: 16px;
  grid-area: serviceList;
}
@media (min-width: 640px) {
  .ServicesList_serviceList__16N3Z {
    margin-top: 16px;
  }
}
@media (min-width: 1200px) {
  .ServicesList_serviceList__16N3Z {
    margin-top: 31px;
  }
}
.ServicesList_serviceList__title__etVjt {
  margin-bottom: 12px;
}
@media (min-width: 1200px) {
  .ServicesList_serviceList__title__etVjt {
    margin-bottom: 16px;
  }
}
.ServicesList_serviceList__title_load__dwKXX {
  height: 18px;
  width: 80px;
  border-radius: 8px;
  color: transparent;
}
.ServicesList_serviceList__logout__fexIM {
  border-radius: 12px;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 111px;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #000;
  width: 29%;
}
.ServicesList_serviceList__16N3Z .ServicesList_serviceList__changeLang__QS3ss {
  width: calc(72% - 12px);
  padding: 16px;
  justify-content: space-between;
  flex-grow: 1;
  font-size: 15px;
  font-weight: 400;
}
.ServicesList_serviceList__16N3Z .ServicesList_serviceList__changeLang__QS3ss img {
  max-width: 25px;
}
.ServicesList_serviceList__logoutAndLang__GrCmb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  gap: 12px;
}
@media (min-width: 640px) {
  .ServicesList_serviceList__logoutAndLang__GrCmb {
    margin-top: 16px;
    grid-gap: 12px;
  }
  .ServicesList_serviceList__logout__fexIM {
    width: calc(50% - 8px);
    max-width: 250px;
  }
  .ServicesList_serviceList__changeLang__QS3ss {
    padding-left: 24px;
    padding-right: 24px;
  }
  .ServicesList_serviceList__changeLang__QS3ss img {
    max-width: 39px;
  }
  .ServicesList_serviceList__logout__fexIM {
    font-size: 20px;
    height: 76px;
  }
}

.ServicesList_gridLoading__lW6IN {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);
}
@media (min-width: 640px) {
  .ServicesList_gridLoading__lW6IN {
    grid-gap: 16px;
  }
}
@media (min-width: 1200px) {
  .ServicesList_gridLoading__lW6IN {
    grid-template-columns: repeat(3, 1fr);
  }
}

.ServicesList_elLoading__SLgPr {
  min-height: 76px;
  border-radius: 12px;
}
@media (min-width: 640px) {
  .ServicesList_elLoading__SLgPr {
    min-height: 104px;
  }
}
@media (min-width: 1200px) {
  .ServicesList_elLoading__SLgPr {
    min-height: 72px;
  }
}
.ServicesList_elLoading__SLgPr:first-child {
  grid-row: span 2;
}

.ServicesList_grid__bT1Ip .selectSkeleton {
  width: 100%;
  height: 66px;
}
.ServicesList_grid__bT1Ip .ServicesList_item__QII46 {
  min-height: 76px;
}
@media (min-width: 640px) {
  .ServicesList_grid__bT1Ip .ServicesList_item__QII46 {
    min-height: 104px;
  }
}
@media (min-width: 1200px) {
  .ServicesList_grid__bT1Ip .ServicesList_item__QII46 {
    min-height: 72px;
  }
}

.ServicesList_row__vbD22 {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 8px;
}
@media (min-width: 640px) {
  .ServicesList_row__vbD22 {
    grid-gap: 16px;
    margin-bottom: 16px;
  }
}
@media (min-width: 1200px) {
  .ServicesList_row__vbD22 {
    grid-template-columns: repeat(3, 1fr);
  }
}
.ServicesList_row__vbD22:last-child {
  margin-bottom: 0;
}
.ServicesList_row--5-1__VmLGu .ServicesList_item__QII46:first-child {
  grid-row: span 2;
}
.ServicesList_row--5-1__VmLGu .ServicesList_item__QII46:first-child img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--5-1__VmLGu .ServicesList_item__QII46:first-child p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--5-2__OwI9L .ServicesList_item__QII46:nth-child(2) {
  grid-row: span 2;
}
.ServicesList_row--5-2__OwI9L .ServicesList_item__QII46:nth-child(2) img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--5-2__OwI9L .ServicesList_item__QII46:nth-child(2) p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--5-3__qyg-6 .ServicesList_item__QII46:nth-child(3) {
  grid-row: span 2;
}
.ServicesList_row--5-3__qyg-6 .ServicesList_item__QII46:nth-child(3) img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--5-3__qyg-6 .ServicesList_item__QII46:nth-child(3) p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--3-1__4LTm5 .ServicesList_item__QII46:nth-child(1) {
  grid-column: span 2;
}
.ServicesList_row--3-1__4LTm5 .ServicesList_item__QII46:nth-child(2) {
  grid-row: span 2;
}
.ServicesList_row--3-1__4LTm5 .ServicesList_item__QII46:nth-child(2) img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--3-1__4LTm5 .ServicesList_item__QII46:nth-child(2) p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--3-1__4LTm5 .ServicesList_item__QII46:nth-child(3) {
  grid-column: span 2;
}
.ServicesList_row--3-2__ys3OO .ServicesList_item__QII46:nth-child(1) {
  grid-row: span 2;
}
.ServicesList_row--3-2__ys3OO .ServicesList_item__QII46:nth-child(1) img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--3-2__ys3OO .ServicesList_item__QII46:nth-child(1) p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--3-2__ys3OO .ServicesList_item__QII46:nth-child(2) {
  grid-column: span 2;
}
.ServicesList_row--3-2__ys3OO .ServicesList_item__QII46:nth-child(3) {
  grid-column: span 2;
}
.ServicesList_row--3-3__M\\+ItU .ServicesList_item__QII46 {
  min-height: 160px;
}
.ServicesList_row--3-3__M\\+ItU .ServicesList_item__QII46 img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--3-3__M\\+ItU .ServicesList_item__QII46 p {
  -webkit-line-clamp: 8;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+1) .ServicesList_item__QII46:first-child {
  grid-row: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+1) .ServicesList_item__QII46:first-child p {
  -webkit-line-clamp: 8;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+1) .ServicesList_item__QII46:last-child {
  grid-column: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+2) .ServicesList_item__QII46:nth-last-child(2) {
  min-height: 220px;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+2) .ServicesList_item__QII46:nth-last-child(2) p {
  -webkit-line-clamp: 6;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+2) .ServicesList_item__QII46:last-child {
  min-height: 220px;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+2) .ServicesList_item__QII46:last-child p {
  -webkit-line-clamp: 6;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+3) .ServicesList_item__QII46:first-child {
  grid-column: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+3) .ServicesList_item__QII46:nth-child(2) {
  grid-row: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+3) .ServicesList_item__QII46:nth-child(2) p {
  -webkit-line-clamp: 6;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+4) .ServicesList_item__QII46:first-child {
  grid-column: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+4) .ServicesList_item__QII46:nth-child(3) {
  grid-row: span 2;
}
.ServicesList_row__vbD22.ServicesList_mob__QkFJc:not([class*=last-mob]):nth-child(4n+4) .ServicesList_item__QII46:nth-child(3) p {
  -webkit-line-clamp: 6;
}
.ServicesList_row--last-1__59MHW .ServicesList_item__QII46 {
  grid-column: span 3;
}
.ServicesList_row--last-2__MQwix {
  grid-template-columns: repeat(2, 1fr);
}
.ServicesList_row--last-3__tgm4R {
  grid-template-columns: repeat(3, 1fr);
  min-height: 160px;
}
.ServicesList_row--last-3__tgm4R img {
  max-width: 158px;
  max-height: 122px;
}
.ServicesList_row--last-3__tgm4R p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--last-4__LunOI .ServicesList_item__QII46:first-child {
  grid-row: span 2;
}
.ServicesList_row--last-4__LunOI .ServicesList_item__QII46:first-child img {
  max-width: 158px;
  max-height: 122px;
  margin-top: auto;
}
.ServicesList_row--last-4__LunOI .ServicesList_item__QII46:first-child p {
  -webkit-line-clamp: 8;
}
.ServicesList_row--last-4__LunOI .ServicesList_item__QII46:last-child {
  grid-column: span 2;
}
.ServicesList_row--last-mob-1__V\\+VJL .ServicesList_item__QII46 {
  grid-column: span 2;
}
.ServicesList_row--last-mob-2__Nofff {
  grid-template-columns: repeat(2, 1fr);
}
.ServicesList_row__vbD22.ServicesList_row--last-mob-3__CoGf9 a.ServicesList_item__QII46 {
  min-height: 76px;
}
.ServicesList_row__vbD22.ServicesList_row--last-mob-3__CoGf9 a.ServicesList_item__QII46:first-child {
  grid-row: span 2;
}
.ServicesList_row__vbD22.ServicesList_row--last-mob-3__CoGf9 a.ServicesList_item__QII46:first-child img {
  max-width: 70px;
  max-height: 100px;
}
@media (min-width: 576px) {
  .ServicesList_row__vbD22.ServicesList_row--last-mob-3__CoGf9 a.ServicesList_item__QII46:first-child img {
    max-width: 158px;
    max-height: 122px;
  }
}
.ServicesList_row__vbD22.ServicesList_row--last-mob-3__CoGf9 a.ServicesList_item__QII46:first-child p {
  -webkit-line-clamp: 6;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesList/ServicesList.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;AACF;AACE;EAJF;IAKI,gBAAA;EAEF;AACF;AAAE;EARF;IASI,gBAAA;EAGF;AACF;AADE;EACE,mBAAA;AAGJ;AADI;EAHF;IAII,mBAAA;EAIJ;AACF;AAFI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAIN;AAAE;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AAEJ;AACE;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EAIA,gBAAA;AAFJ;AADI;EACE,eAAA;AAGN;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;AAAJ;AAGE;EACE;IACE,gBAAA;IACA,cAAA;EADJ;EAIE;IACE,sBAAA;IACA,gBAAA;EAFJ;EAKE;IACE,kBAAA;IACA,mBAAA;EAHJ;EAII;IACE,eAAA;EAFN;EAME;IACE,eAAA;IACA,YAAA;EAJJ;AACF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,qCAAA;AALF;AAOE;EALF;IAMI,cAAA;EAJF;AACF;AAME;EATF;IAUI,qCAAA;EAHF;AACF;;AAMA;EACE,gBAAA;EACA,mBAAA;AAHF;AAKE;EAJF;IAKI,iBAAA;EAFF;AACF;AAIE;EARF;IASI,gBAAA;EADF;AACF;AAGE;EACE,gBAAA;AADJ;;AAOI;EACE,WAAA;EACA,YAAA;AAJN;AAQE;EACE,gBAAA;AANJ;AAQI;EAHF;IAII,iBAAA;EALJ;AACF;AAOI;EAPF;IAQI,gBAAA;EAJJ;AACF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,qCAAA;EACA,kBAAA;AALF;AAOE;EANF;IAOI,cAAA;IACA,mBAAA;EAJF;AACF;AAME;EAXF;IAYI,qCAAA;EAHF;AACF;AAKE;EACE,gBAAA;AAHJ;AAQM;EACE,gBAAA;AANR;AAQQ;EACE,gBAAA;EACA,iBAAA;AANV;AASQ;EACE,qBAAA;AAPV;AAeM;EACE,gBAAA;AAbR;AAeQ;EACE,gBAAA;EACA,iBAAA;AAbV;AAgBQ;EACE,qBAAA;AAdV;AAsBM;EACE,gBAAA;AApBR;AAsBQ;EACE,gBAAA;EACA,iBAAA;AApBV;AAuBQ;EACE,qBAAA;AArBV;AA6BM;EACE,mBAAA;AA3BR;AA6BM;EACE,gBAAA;AA3BR;AA6BQ;EACE,gBAAA;EACA,iBAAA;AA3BV;AA8BQ;EACE,qBAAA;AA5BV;AA+BM;EACE,mBAAA;AA7BR;AAoCM;EACE,gBAAA;AAlCR;AAoCQ;EACE,gBAAA;EACA,iBAAA;AAlCV;AAqCQ;EACE,qBAAA;AAnCV;AAsCM;EACE,mBAAA;AApCR;AAsCM;EACE,mBAAA;AApCR;AA0CI;EACE,iBAAA;AAxCN;AA0CM;EACE,gBAAA;EACA,iBAAA;AAxCR;AA2CM;EACE,qBAAA;AAzCR;AAiDQ;EACE,gBAAA;AA/CV;AAiDU;EACE,qBAAA;AA/CZ;AAkDQ;EACE,mBAAA;AAhDV;AAuDQ;EACE,iBAAA;AArDV;AAuDU;EACE,qBAAA;AArDZ;AAwDQ;EACE,iBAAA;AAtDV;AAwDU;EACE,qBAAA;AAtDZ;AA8DQ;EACE,mBAAA;AA5DV;AA8DQ;EACE,gBAAA;AA5DV;AA8DU;EACE,qBAAA;AA5DZ;AAoEQ;EACE,mBAAA;AAlEV;AAoEQ;EACE,gBAAA;AAlEV;AAoEU;EACE,qBAAA;AAlEZ;AA0EI;EACE,mBAAA;AAxEN;AA4EE;EACE,qCAAA;AA1EJ;AA6EE;EACE,qCAAA;EACA,iBAAA;AA3EJ;AA6EI;EACE,gBAAA;EACA,iBAAA;AA3EN;AA8EI;EACE,qBAAA;AA5EN;AAkFM;EACE,gBAAA;AAhFR;AAkFQ;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhFV;AAmFQ;EACE,qBAAA;AAjFV;AAoFM;EACE,mBAAA;AAlFR;AAwFI;EACE,mBAAA;AAtFN;AA0FE;EACE,qCAAA;AAxFJ;AA4FI;EACE,gBAAA;AA1FN;AA4FM;EACE,gBAAA;AA1FR;AA4FQ;EACE,eAAA;EACA,iBAAA;AA1FV;AA4FU;EAJF;IAKI,gBAAA;IACA,iBAAA;EAzFV;AACF;AA4FQ;EACE,qBAAA;AA1FV","sourcesContent":[".serviceList {\n  margin-top: 16px;\n  grid-area: serviceList;\n\n  @media (min-width: 640px) {\n    margin-top: 16px;\n  }\n\n  @media (min-width: 1200px) {\n    margin-top: 31px;\n  }\n\n  &__title {\n    margin-bottom: 12px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 16px;\n    }\n\n    &_load {\n      height: 18px;\n      width: 80px;\n      border-radius: 8px;\n      color: transparent;\n    }\n  }\n\n  &__logout {\n    border-radius: 12px;\n    background: #eee;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 44px;\n    width: 111px;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    color: #000;\n    width: 29%;\n  }\n\n  & &__changeLang {\n    width: calc(72% - 12px);\n    padding: 16px;\n    justify-content: space-between;\n    flex-grow: 1;\n    font-size: 15px;\n    img {\n      max-width: 25px;\n    }\n    font-weight: 400;\n  }\n\n  &__logoutAndLang {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n    gap: 12px;\n  }\n\n  @media (min-width: 640px) {\n    &__logoutAndLang {\n      margin-top: 16px;\n      grid-gap: 12px;\n    }\n\n    &__logout {\n      width: calc(50% - 8px);\n      max-width: 250px;\n    }\n\n    &__changeLang {\n      padding-left: 24px;\n      padding-right: 24px;\n      img {\n        max-width: 39px;\n      }\n    }\n\n    &__logout {\n      font-size: 20px;\n      height: 76px;\n    }\n  }\n}\n\n.gridLoading {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(2, 1fr);\n\n  @media (min-width: 640px) {\n    grid-gap: 16px;\n  }\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.elLoading {\n  min-height: 76px;\n  border-radius: 12px;\n\n  @media (min-width: 640px) {\n    min-height: 104px;\n  }\n\n  @media (min-width: 1200px) {\n    min-height: 72px;\n  }\n\n  &:first-child {\n    grid-row: span 2;\n  }\n}\n\n.grid {\n  :global {\n    .selectSkeleton {\n      width: 100%;\n      height: 66px;\n    }\n  }\n\n  .item {\n    min-height: 76px;\n\n    @media (min-width: 640px) {\n      min-height: 104px;\n    }\n\n    @media (min-width: 1200px) {\n      min-height: 72px;\n    }\n  }\n}\n\n.row {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(2, 1fr);\n  margin-bottom: 8px;\n\n  @media (min-width: 640px) {\n    grid-gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &--5-1 {\n    .item {\n      &:first-child {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n    }\n  }\n\n  &--5-2 {\n    .item {\n      &:nth-child(2) {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n    }\n  }\n\n  &--5-3 {\n    .item {\n      &:nth-child(3) {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n    }\n  }\n\n  &--3-1 {\n    .item {\n      &:nth-child(1) {\n        grid-column: span 2;\n      }\n      &:nth-child(2) {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n      &:nth-child(3) {\n        grid-column: span 2;\n      }\n    }\n  }\n\n  &--3-2 {\n    .item {\n      &:nth-child(1) {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n      &:nth-child(2) {\n        grid-column: span 2;\n      }\n      &:nth-child(3) {\n        grid-column: span 2;\n      }\n    }\n  }\n\n  &--3-3 {\n    .item {\n      min-height: 160px;\n\n      img {\n        max-width: 158px;\n        max-height: 122px;\n      }\n\n      p {\n        -webkit-line-clamp: 8;\n      }\n    }\n  }\n\n  &.mob:not([class*=last-mob]) {\n    &:nth-child(4n + 1) {\n      .item {\n        &:first-child {\n          grid-row: span 2;\n\n          p {\n            -webkit-line-clamp: 8;\n          }\n        }\n        &:last-child {\n          grid-column: span 2;\n        }\n      }\n    }\n\n    &:nth-child(4n + 2) {\n      .item {\n        &:nth-last-child(2) {\n          min-height: 220px;\n\n          p {\n            -webkit-line-clamp: 6;\n          }\n        }\n        &:last-child {\n          min-height: 220px;\n\n          p {\n            -webkit-line-clamp: 6;\n          }\n        }\n      }\n    }\n\n    &:nth-child(4n + 3) {\n      .item {\n        &:first-child {\n          grid-column: span 2;\n        }\n        &:nth-child(2) {\n          grid-row: span 2;\n\n          p {\n            -webkit-line-clamp: 6;\n          }\n        }\n      }\n    }\n\n    &:nth-child(4n + 4) {\n      .item {\n        &:first-child {\n          grid-column: span 2;\n        }\n        &:nth-child(3) {\n          grid-row: span 2;\n\n          p {\n            -webkit-line-clamp: 6;\n          }\n        }\n      }\n    }\n  }\n\n  &--last-1 {\n    .item {\n      grid-column: span 3;\n    }\n  }\n\n  &--last-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  &--last-3 {\n    grid-template-columns: repeat(3, 1fr);\n    min-height: 160px;\n\n    img {\n      max-width: 158px;\n      max-height: 122px;\n    }\n\n    p {\n      -webkit-line-clamp: 8;\n    }\n  }\n\n  &--last-4 {\n    .item {\n      &:first-child {\n        grid-row: span 2;\n\n        img {\n          max-width: 158px;\n          max-height: 122px;\n          margin-top: auto;\n        }\n\n        p {\n          -webkit-line-clamp: 8;\n        }\n      }\n      &:last-child {\n        grid-column: span 2;\n      }\n    }\n  }\n\n  &--last-mob-1 {\n    .item {\n      grid-column: span 2;\n    }\n  }\n\n  &--last-mob-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  &.row--last-mob-3 {\n    a.item {\n      min-height: 76px;\n\n      &:first-child {\n        grid-row: span 2;\n\n        img {\n          max-width: 70px;\n          max-height: 100px;\n\n          @media (min-width: 576px) {\n            max-width: 158px;\n            max-height: 122px;\n          }\n        }\n\n        p {\n          -webkit-line-clamp: 6;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceList": `ServicesList_serviceList__16N3Z`,
	"serviceList__title": `ServicesList_serviceList__title__etVjt`,
	"serviceList__title_load": `ServicesList_serviceList__title_load__dwKXX`,
	"serviceList__logout": `ServicesList_serviceList__logout__fexIM`,
	"serviceList__changeLang": `ServicesList_serviceList__changeLang__QS3ss`,
	"serviceList__logoutAndLang": `ServicesList_serviceList__logoutAndLang__GrCmb`,
	"gridLoading": `ServicesList_gridLoading__lW6IN`,
	"elLoading": `ServicesList_elLoading__SLgPr`,
	"grid": `ServicesList_grid__bT1Ip`,
	"item": `ServicesList_item__QII46`,
	"row": `ServicesList_row__vbD22`,
	"row--5-1": `ServicesList_row--5-1__VmLGu`,
	"row--5-2": `ServicesList_row--5-2__OwI9L`,
	"row--5-3": `ServicesList_row--5-3__qyg-6`,
	"row--3-1": `ServicesList_row--3-1__4LTm5`,
	"row--3-2": `ServicesList_row--3-2__ys3OO`,
	"row--3-3": `ServicesList_row--3-3__M+ItU`,
	"mob": `ServicesList_mob__QkFJc`,
	"row--last-1": `ServicesList_row--last-1__59MHW`,
	"row--last-2": `ServicesList_row--last-2__MQwix`,
	"row--last-3": `ServicesList_row--last-3__tgm4R`,
	"row--last-4": `ServicesList_row--last-4__LunOI`,
	"row--last-mob-1": `ServicesList_row--last-mob-1__V+VJL`,
	"row--last-mob-2": `ServicesList_row--last-mob-2__Nofff`,
	"row--last-mob-3": `ServicesList_row--last-mob-3__CoGf9`
};
export default ___CSS_LOADER_EXPORT___;
